<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar actividad"
                        aria-label="Agregar actividad"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 240px; max-width: 320px;">
              <label class="filter-label">Buscar</label>
              <b-form-input type="text" size="sm" placeholder="Buscar por asignación u observación" v-model="table.filter"></b-form-input>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col sm="6">
          <b-card>
            <FullCalendar ref="sellersCalendar"
                          defaultView="dayGridMonth"
                          :plugins="calendarPlugins"
                          :locale="calendarOptions.locale"
                          :weekends="true"
                          :events="calendarOptions.event"
                          :titleFormat="calendarTitleFormat"
                          :dayRender="onCalendarDayRender"
                          :datesRender="onCalendarDatesRender"/>
          </b-card>
        </b-col>
        <b-col sm="6">

          <b-card>
            <b-row class="mb-3" v-if="sellers.staff">
              <b-col md="12">
                <b-avatar :src="sellers.staff.image"
                          size="25px"
                          v-if="sellers.staff.image">
                </b-avatar>
                <b-avatar v-else
                          size="25px"
                          :text="avatarFromName(sellers.name).text"
                          :style="avatarFromName(sellers.name).style">
                </b-avatar>
                &nbsp;<b>{{sellers.name}}</b>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-table class="app-table crud-sellers-calendar-table"
                        responsive="sm"
                        sticky-header="60vh"
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :tbody-tr-class="rowClass"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        v-if="table.items.length">

                    <template v-slot:cell(date_start)="data">
                      {{moment(data.item.date_start).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(date_end)="data">
                      {{moment(data.item.date_end).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(assignment)="data">
                      <div v-if="data.item.zone">
                        <b>Visita:</b> {{data.item.zone.name}}
                      </div>
                      <div v-else>
                        {{data.item.activity}}
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observation" class="text-truncate" v-b-tooltip.hover :title="data.item.observation">
                        {{data.item.observation}}
                      </div>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-sellers-calendar-action-toggle-labeled' : 'app-table-action-toggle'">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else
                            icon="calendar"
                            title="No se encontraron registros"
                            description="Probá otro mes en el calendario, ajustá la búsqueda o agregá una actividad nueva con el botón Agregar." />
              </b-col>
            </b-row>

          </b-card>
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav>
                <b-pagination class="mb-0"
                              size="sm"
                              pills
                              :total-rows="getRowCount(table.items)"
                              :per-page="table.perPage"
                              v-model="table.currentPage"
                              v-if="table.items.length" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon :name="modal.form.icon" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Tipo">
              <b-form-radio-group
                v-model="crud.form.type.selected"
                :options="crud.form.type.options"
                name="radios-type"
                buttons
                button-variant="outline-dark"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Fecha Inicio" class="text-center">
              <b-form-datepicker size="sm" v-model="crud.form.date_start" placeholder="Fecha Inicio" local="es"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Fecha Fin" class="text-center">
              <b-form-datepicker size="sm" v-model="crud.form.date_end" placeholder="Fecha Fin" local="es"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <FindObject type="sellersZone"
                        @select-object="loadSellersZone($event)"
                        :valueID="crud.form.zone_id"
                        :where="conditionFindZone"
                        v-show="crud.form.type.selected == 'zone'"/>

            <b-form-group label="Actividad"
                          description="Actividad que se ve afectado un vendedor cuando no tiene zonas asignadas"
                          v-show="crud.form.type.selected == 'activity'">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.activity"
                            placeholder="Ingresar la actividad">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones">
              <app-textarea
                v-model="crud.form.observation"
                size="sm"
                placeholder="Ingresa una observación"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Profiles from '@/config/profiles'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import esLocale from '@fullcalendar/core/locales/es';
  import interactionPlugin from '@fullcalendar/interaction';

  export default {
    components: {
      FindObject,
      FullCalendar,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.VENDEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudSellersCalendar',
          elements: {}
        },
        calendarPlugins: [ dayGridPlugin, interactionPlugin ],
        calendarOptions: {
          locale: esLocale,
          event: []
        },
        sellersID: 0,
        sellers: {},
        // Panel de filtros: cerrado por default; el usuario que lo abre
        // queda con su preferencia persistida (ver watcher filtersOpen).
        filtersOpen: false,
        // stacked (modo card mobile) y sticky-header son mutuamente
        // excluyentes en BootstrapVue — stacked solo se activa cuando el
        // viewport realmente está en mobile (ver mounted/beforeDestroy).
        isMobileViewport: false,
        // Rango de fechas actualmente visible en el calendario (mes
        // mostrado, con el padding de semanas de meses vecinos ya
        // excluido) — se actualiza con cada navegación y se usa para
        // filtrar la lista sin volver a pedir datos al servidor.
        calendarVisibleRange: null,
        table : {
          items: [],
          // Listado completo del vendedor, sin filtrar por mes — la fuente
          // de la que se derivan table.items en cada navegación del
          // calendario (ver filterItemsByMonth).
          allItems: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 10,
        },
        crud: {
          form: {
            date_start: moment().format('YYYY-MM-DD'),
            date_end: moment().add(7, 'days').format('YYYY-MM-DD'),
            type: {
              selected: 'zone',
              options: [
                { text: 'Zona', value: 'zone' },
                { text: 'Actividad', value: 'activity' }
              ]
            },
            zone_id: 0,
            zone: null,
            activity: "",
            observation: '',
            sellers_id: 0,
          }
        },
        modal: {
          form: {
            active: false,
            title: '',
            icon: 'add',
          },
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted () {
      this.sellersID = this.$route.params.sellersID

      moment.locale('es');

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_sellers_calendar') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_crud_sellers_calendar', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación y el label del kebab tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
      // Al cambiar el tipo (Zona/Actividad) hay que limpiar el otro campo:
      // si no, el valor viejo queda pisado en el form y se termina
      // guardando con el tipo anterior (ej. editar un item de Zona,
      // pasarlo a Actividad, pero zone_id sigue con el valor original).
      'crud.form.type.selected'(value) {
        if(value == 'zone') {
          this.crud.form.activity = ''
        } else {
          this.crud.form.zone_id = 0
          this.crud.form.zone = null
        }
      },
    },
    computed: {
      conditionFindZone(){
        return [{field: 'sellers_id', condition: this.sellersID}];
      }
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'date_start', label: 'Fecha Inicio', sortable: true, class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'date_end', label: 'Fecha Fin', sortable: true, class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'assignment', label: 'Asignación', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'observations', label: 'Observaciones', class: "align-middle " + this.alignClass('text-center')})
        // Sin drawer que aloje las acciones en mobile, el kebab se
        // conserva ahí también, con label y texto "Opciones" visibles.
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: "align-middle " + this.alignClass('text-right')})
      },
      getRowCount (items) {
        return items.length
      },
      // El titleFormat automático del locale es.js arma "enero de 2026" (el
      // "de" es gramática española correcta para esa combinación, no un
      // error del locale) -- queremos solo "Enero 2026", así que se arma a
      // mano en vez de dejarle el formateo por defecto a FullCalendar.
      //
      // moment.utc(), NO moment(): arg.date.marker está en el dominio UTC
      // (medianoche UTC = 1° del mes) sin importar el timezone real; leerlo
      // con moment() local lo corre un mes atrás en husos negativos (ej.
      // Argentina UTC-3: "Julio" en vez de "Agosto").
      calendarTitleFormat(arg) {
        var text = moment.utc(arg.date.marker).format('MMMM YYYY')
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      // Resalta, con el mismo lenguaje visual que la fila activa de un
      // drawer (.app-table-row-active), la actividad cuyo rango de fechas
      // incluye el día de hoy — el indicador de "semana actual" pedido
      // para la lista.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(moment().isBetween(item.date_start, item.date_end, 'day', '[]')) {
          return 'app-table-row-active'
        }
        return ''
      },
      // Mismo indicador de "semana actual", pero en el calendario: pinta
      // los 7 días de la semana ISO en curso (no solo "hoy"), para que se
      // pueda ubicar de un vistazo qué franja del mes mostrado es la
      // semana actual.
      onCalendarDayRender(info) {
        var cellDate = moment(info.date)
        var today = moment()
        if(cellDate.isoWeek() === today.isoWeek() && cellDate.isoWeekYear() === today.isoWeekYear()) {
          info.el.classList.add('crud-sellers-calendar-current-week')
        }
      },
      // La lista se filtra según el mes que el calendario tiene mostrado
      // en cada momento (currentStart/currentEnd ya excluyen el padding de
      // días de meses vecinos que sí se ven en la grilla).
      onCalendarDatesRender(info) {
        this.calendarVisibleRange = {
          start: info.view.currentStart,
          end: info.view.currentEnd,
        }
        this.filterItemsByMonth()
      },
      filterItemsByMonth() {
        if(!this.calendarVisibleRange) {
          this.table.items = this.table.allItems
          return
        }

        var start = moment(this.calendarVisibleRange.start)
        var end = moment(this.calendarVisibleRange.end)

        this.table.items = this.table.allItems.filter(item => {
          return moment(item.date_start).isBefore(end) && moment(item.date_end).isSameOrAfter(start, 'day')
        })
      },
      load() {
        this.loadCalendar()
        this.loadCalendarBySellers()
      },
      loadCalendar() {
        let loader = this.$loading.show();

        this.calendarOptions.event = []

        var result = serviceAPI.mostrarVendedor(this.sellersID)

        result.then((response) => {
          var data = response.data
          this.sellers = data

          data.calendars.forEach(element => {
            var activityTitle = ''
            var colorHexa = ''
            if(element.zone_id) {
              activityTitle = 'Visita: ' + element.zone.name
              colorHexa = '#4caf5073'
            }
            else {
              activityTitle = element.activity
              colorHexa = '#e613047d'
            }

            var event = {}

            event = {
              title: activityTitle,
              start: element.date_start,
              // En la base date_end es inclusiva, pero FullCalendar la
              // interpreta como exclusiva para eventos de día completo.
              allDay: true,
              end: moment(element.date_end).add(1, 'day').format('YYYY-MM-DD'),
              color: colorHexa,
            }
            this.calendarOptions.event.push(event)
          });

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      loadCalendarBySellers() {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerCalendarioBySellers({sellers_id: this.sellersID})

        result.then((response) => {
          var data = response.data
          // Orden ascendente por fecha de inicio -- la lista se lee como
          // una línea de tiempo (semana 1, semana 2, ...) en vez del orden
          // de carga que devuelve el servidor.
          data.sort((a, b) => moment(a.date_start).diff(moment(b.date_start)))
          this.table.allItems = data
          this.filterItemsByMonth()
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.type.selected = 'zone'
        this.crud.form.sellers_id = this.sellersID
        this.crud.form.zone_id = 0
        this.crud.form.zone = null
        this.crud.form.activity = ''
        this.crud.form.observation = ''
        this.setNextDate()

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Agregar Actividad"
        this.modal.form.icon = 'add'
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.sellers_id = item.sellers_id
        if(item.zone_id) {
          this.crud.form.type.selected = 'zone'
          this.crud.form.zone_id = item.zone_id
          this.crud.form.zone = item.zone
          this.crud.form.activity = ''
        } else {
          this.crud.form.type.selected = 'activity'
          this.crud.form.zone_id = 0
          this.crud.form.zone = null
          this.crud.form.activity = item.activity
        }
        this.crud.form.observation = item.observation
        this.crud.form.date_start = item.date_start
        this.crud.form.date_end = item.date_end

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Actividad"
        this.modal.form.icon = 'edit'
        this.modal.form.active = true
      },
      // Confirm estándar: header con ícono + tinte suave
      // (.app-confirm-header) en vez de header-bg-variant sólido, size
      // 'sm' siempre, y okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      remove(item) {
        this.crud.form.id = item.id
        if(item.zone_id) {
          this.crud.form.name = "Zona: " + item.zone.name
        } else {
          this.crud.form.name = "Actividad: " + item.activity
        }

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Actividad',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCalendario(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarCalendario(this.crud.form);
        } else {
          var result = serviceAPI.agregarCalendario(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadSellersZone (object) {
        if(object){
          this.crud.form.zone = object
          this.crud.form.zone_id = object.id
        } else {
          this.crud.form.zone = null
          this.crud.form.zone_id = 0
        }
      },
      setNextDate() {
        // table.allItems ya viene ordenado ascendente (ver
        // loadCalendarBySellers) -- el último es el de fecha de fin más
        // reciente, sin importar qué mes tenga filtrado la lista.
        if(this.table.allItems.length){
          var lastItem = this.table.allItems[this.table.allItems.length - 1]
          this.crud.form.date_start = moment(lastItem.date_end).format('YYYY-MM-DD')
          this.crud.form.date_end = moment(lastItem.date_end).add(7, 'days').format('YYYY-MM-DD')
        } else {
          this.crud.form.date_start = moment().format('YYYY-MM-DD')
          this.crud.form.date_end = moment().add(7, 'days').format('YYYY-MM-DD')
        }
      }
    }
  }
</script>
<style scoped>
  /* Excepción al kebab mudo de .app-table: esta tabla no tiene drawer que
     aloje las acciones, así que se conserva también en mobile — como link
     de texto alineado a la izquierda, no como botón con caja. */
  .btn.crud-sellers-calendar-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-sellers-calendar-action-toggle-labeled:hover,
  .btn.crud-sellers-calendar-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  /* Pisa la regla global que oculta el label del último field y lo alinea
     a la derecha (pensada para el kebab ícono-only sin texto). */
  @media (max-width: 767.98px) {
    .crud-sellers-calendar-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-sellers-calendar-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
<style>
  /* Sin scoped: las celdas del día las crea FullCalendar por su cuenta,
     fuera del árbol de render de Vue, así que el atributo data-v-* del
     componente nunca llega a pintarlas (mismo motivo por el que el CSS de
     un b-sidebar tampoco puede ir scoped). Resalta toda la semana ISO en
     curso -- no solo "hoy" -- para ubicar de un vistazo qué franja del mes
     mostrado es la semana actual (mismo indicador que .app-table-row-active
     en la lista). */
  .fc-day.crud-sellers-calendar-current-week {
    background-color: var(--app-color-primary-soft) !important;
  }
</style>
